export default __webpack_public_path__ + "static/media/Unfiled.8083bc24.svg";